module.exports = {
    apiKey: "AIzaSyA84cy4GxQecaDTlDKPD05O3YG5FiKzvIE",
    authDomain: "live-polling-f59d1.firebaseapp.com",
    projectId: "live-polling-f59d1",
    storageBucket: "live-polling-f59d1.appspot.com",
    messagingSenderId: "183174542680",
    appId: "1:183174542680:web:c845160415a469ae01e12d",
    measurementId: "G-LQ15H8WK7Y"
  };